import { type FC, useContext } from "react";
import { Stack, useTheme } from "@mui/material";

import { ProductionContext } from "@/contexts/production";
import { BodyMedium } from "@/components/typography";
import { ScanInput } from "@/views/production/orders/scan-input/scan-input";
import { OrdersContext } from "@/views/production/orders/orders.context";
import { JobQueueContext } from "@/views/production/orders/job-queue-provider";
import { MachineGroupStatusMessage } from "@/views/production/orders/machine-group-status-message/machine-group-status-message";
import { getMachineStatusColor } from "@/utils/machine-status-utils";
import { HistoryLink } from "@/components/history-link";

import { MachineGroupStatusIcon } from "../components/machine-group-status";

export const OrdersHeader: FC = () => {
	const { currentMachineGroup } = useContext(ProductionContext);
	const { triggerJobByLPN } = useContext(OrdersContext);
	const { selectedBatches, batchesLoading } = useContext(JobQueueContext);
	const theme = useTheme();
	const jobsInProgress = !batchesLoading && selectedBatches && selectedBatches.length > 0;
	const productionEnabled = currentMachineGroup?.productionEnabled || false;

	if (!currentMachineGroup) return null;

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			padding={2}
			sx={{
				bgcolor: getMachineStatusColor({
					status: currentMachineGroup.status,
					productionEnabled,
					theme,
				}),
			}}
		>
			<Stack direction="row" spacing={1} alignItems="center">
				{jobsInProgress === true && (
					<>
						{!productionEnabled && (
							<MachineGroupStatusIcon
								status={currentMachineGroup.status}
								productionEnabled={productionEnabled}
								useColor={false}
							/>
						)}
						<BodyMedium>
							<MachineGroupStatusMessage />
						</BodyMedium>
					</>
				)}
			</Stack>
			<Stack direction="row" spacing={2} alignItems="center">
				<ScanInput triggerJobByLPN={(_, lpn) => triggerJobByLPN(currentMachineGroup.id, lpn)} />
				<HistoryLink />
			</Stack>
		</Stack>
	);
};
